var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',_vm._g(_vm._b({ref:"loadableButton",class:_vm.effectiveClass,attrs:{"color":_vm.color,"disabled":_vm.disabled || _vm.isLoading}},'vs-button',_vm.$attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }